'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Heading = function Heading(_ref) {
  var children = _ref.children,
      smallScreen = _ref.smallScreen,
      env = _ref.env,
      level = _ref.level;

  var classNames = (0, _classnames2.default)(_styles2.default.heading, _styles2.default['heading--' + env], _styles2.default['heading--' + level], _defineProperty({}, _styles2.default['heading--smallScreen'], smallScreen));
  return _react2.default.createElement(
    'div',
    { className: classNames },
    children
  );
};

Heading.propTypes = {
  children: _react.PropTypes.string.isRequired,
  env: _react.PropTypes.oneOf(['light', 'dark']),
  level: _react.PropTypes.oneOf(['one', 'two', 'three']).isRequired,
  smallScreen: _react.PropTypes.bool
};

Heading.defaultProps = {
  env: 'light',
  smallScreen: false
};

exports.default = Heading;